import { Component, input, output, signal } from '@angular/core';
import { DateRange, DateRangePickerComponent } from '../date-range-picker/date-range-picker';
import { SelectComponent, SelectOption } from '../select/select';

export interface FilterState {
  search: string;
  programId: string;
  categoryId: string;
  dateFrom: string;
  dateTo: string;
  /** Only emitted when the bar is given `stages` options. */
  stage?: string;
  /** Only emitted when the bar is given `statuses` options. */
  status?: string;
}

const EMPTY: FilterState = {
  search: '',
  programId: '',
  categoryId: '',
  dateFrom: '',
  dateTo: '',
  stage: '',
  status: '',
};

@Component({
  selector: 'app-filter-bar',
  imports: [DateRangePickerComponent, SelectComponent],
  templateUrl: './filter-bar.html',
})
export class FilterBarComponent {
  /** Optional Stage filter; hidden when empty. */
  stages = input<SelectOption[]>([]);
  /** Optional Status filter (investigations: Open / Closed); hidden when empty. */
  statuses = input<SelectOption[]>([]);
  programs = input<SelectOption[]>([]);
  categories = input<SelectOption[]>([]);
  /** What the search box matches differs per feed (incidents: person name only). */
  searchPlaceholder = input('Filter by person name ...');

  filtersChange = output<FilterState>();

  protected search = signal('');
  protected selectedProgram = signal('');
  protected selectedCategory = signal('');
  protected selectedStage = signal('');
  protected selectedStatus = signal('');
  protected dateFrom = signal('');
  protected dateTo = signal('');

  protected setSearch(value: string): void {
    this.search.set(value);
    this.emit();
  }

  protected setProgram(value: string): void {
    this.selectedProgram.set(value);
    this.emit();
  }

  protected setCategory(value: string): void {
    this.selectedCategory.set(value);
    this.emit();
  }

  protected setStage(value: string): void {
    this.selectedStage.set(value);
    this.emit();
  }

  protected setStatus(value: string): void {
    this.selectedStatus.set(value);
    this.emit();
  }

  protected onRangeChange(range: DateRange): void {
    this.dateFrom.set(range.from);
    this.dateTo.set(range.to);
    this.emit();
  }

  protected reset(): void {
    this.search.set('');
    this.selectedProgram.set('');
    this.selectedCategory.set('');
    this.selectedStage.set('');
    this.selectedStatus.set('');
    this.dateFrom.set('');
    this.dateTo.set('');
    this.filtersChange.emit({ ...EMPTY });
  }

  private emit(): void {
    this.filtersChange.emit({
      search: this.search(),
      programId: this.selectedProgram(),
      categoryId: this.selectedCategory(),
      dateFrom: this.dateFrom(),
      dateTo: this.dateTo(),
      stage: this.selectedStage(),
      status: this.selectedStatus(),
    });
  }
}
